/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const VoidBillingInvoiceInputJsonApiModel = {
  id: "",
  "billing-invoice": {
    jsonApi: "hasOne",
    type: "billing-invoices",
  },
  "stripe-invoice-status": "",
};
